import { useCallback, useEffect, useRef, useState } from 'react';
import { THROTTLE_MS } from '../constants/THROTTLING';
export const useMediaQuery = (breakpoints, defaultSize) => {
  const setTimeoutRef = useRef(undefined);
  const mediaQueryList = Object.values(breakpoints).map(query => window.matchMedia(query));
  const getCurrentScreen = useCallback(() => {
    const matches = mediaQueryList.filter(mql => mql.matches);
    const matchedScreenSize = matches && matches[0] ? matches[0].media : undefined;
    return matchedScreenSize !== undefined ? Object.keys(breakpoints).find(key => breakpoints[key] === matchedScreenSize) : defaultSize;
  }, [mediaQueryList, breakpoints, defaultSize]);
  const [match, setMatch] = useState(getCurrentScreen());
  useEffect(() => {
    if (mediaQueryList && mediaQueryList.length) {
      const update = () => setMatch(getCurrentScreen());
      const throttleMediaQuery = () => {
        if (setTimeoutRef.current !== undefined) {
          clearTimeout(setTimeoutRef.current);
        }
        setTimeoutRef.current = setTimeout(() => {
          update();
        }, THROTTLE_MS);
        return () => clearTimeout(setTimeoutRef.current);
      };
      mediaQueryList.forEach(mql => mql.addEventListener('change', () => {
        throttleMediaQuery();
      }));
      return () => mediaQueryList.forEach(mql => mql.removeEventListener('change', () => {
        throttleMediaQuery();
      }));
    }
  }, [getCurrentScreen, mediaQueryList]);
  return match || defaultSize;
};